// Estado de autenticação (nanostores). $user é a ÚNICA fonte de verdade sobre
// quem está logado. Sem token/refresh — a sessão é o cookie httpOnly.
import { atom } from 'nanostores';
import type { User } from '@mindlab/shared';
import { authApi } from '../api/endpoints.js';

export const $user = atom<User | null>(null);
export const $authChecked = atom<boolean>(false);

/** Consulta /auth/me no boot para popular a sessão. */
export async function checkSession(signal?: AbortSignal): Promise<User | null> {
  try {
    const { user } = await authApi.me(signal);
    $user.set(user);
    return user;
  } catch {
    $user.set(null);
    return null;
  } finally {
    $authChecked.set(true);
  }
}

export async function logout(): Promise<void> {
  try {
    await authApi.logout();
  } finally {
    $user.set(null);
  }
}
